<template>
        <!-- >>> Treeview Container -->
        <div class="treeviewcontainer">
            <!-- >>> Treeview Header -->
            <sdr-selected-flight-list-header
                style="position:sticky;top:0;z-index:2" />
            <!-- <<< Treeview Header -->

            <!-- >>> Treeview -->
            <v-treeview
                v-if="selectedFlights.length > 0"
                v-model="flightList"
                :items="selectedFlights"
                return-object
                item-key="idFlight"
                color="primary"
                selectable
                :selection-type="'leaf'"
                open-all>
                <template v-slot:label="{ item }">
                    <sdr-selected-flight-list-item
                        :item="item" />
                </template>
            </v-treeview>
            <!-- <<< Treeview -->
            <v-list-item v-else style="min-height: 55px;padding:0;">
                <template>
                    <v-list-item-content style="display:flex;align-items:center;justify-content:center;margin:0;">
                        No Flights selected
                    </v-list-item-content>
                </template>
            </v-list-item>
        </div>
        <!-- <<< Treeview Container -->
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';

    import SelectedFlightListItem from './SelectedFlightListItem.vue';
    import SelectedFlightListHeader from './SelectedFlightListHeader.vue';



    export default {
        name: 'Selectedflightslist',
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-selected-flight-list-item': SelectedFlightListItem,
            'sdr-selected-flight-list-header': SelectedFlightListHeader

        },

        /* >>> *************************************************************** / /* Props */
        props: {
            selectedFlights: Array
        }, // eof components{}
        /* <<< *****************************************************************


        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                flightList: []
            };

        }, // eo data()
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([])


        }, // eo computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Watch */
        watch: {

            flightList(val) {

                const me = this;


                eventBus.$emit('flightlistchanged', val);
            }
        }, // eo watch{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightList.vue >>> created');


        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightList.vue >>> mounted');
            me.flightList = me.selectedFlights;

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightList.vue >>> destroyed');

        }, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* methods */
        methods: {

            ...mapActions([])


        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
.v-treeview-node:nth-child(2n+1) {
    background: rgb(244, 244, 244);
}

.v-treeview > .v-treeview-node--leaf {
    padding-left: 0px !important;
    margin-left: 0px !important;
}

.v-treeview-node__children {
    background: white;
}
</style>

<style scoped>

.dragbar {
    position:absolute;
    bottom:0;
    width:100%;
    height:7px;
    background-color:#e5e5e8;
    text-align:center;
    cursor:ns-resize;
}

.hover {
    height: 13px;
}

</style>
